import script from "./ResumeLicences.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeLicences.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeLicences.vue?vue&type=style&index=0&id=4e08e8d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e08e8d8"]])

export default __exports__